import React, { useState, useCallback, useRef } from "react";
import activityStyles from "./CaseActivity.module.scss";

export const FileDragDrop = ({
    children,
    onFilesDrop,
    onOverGridChange,
    onDragEnd,
    isDraggingFile,
    isOverGrid,
}) => {
    const [dragging, setDragging] = useState(false);
    const containerRef = useRef(null);

    const hasFilesTransfer = useCallback((e) => {
        const types = e?.dataTransfer?.types;
        if (!types) return false;
        return typeof types.contains === "function"
            ? types.contains("Files")
            : Array.from(types).includes("Files");
    }, []);

    const handleDragEnter = useCallback(
        (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (hasFilesTransfer(e)) {
                setDragging(true);
                onOverGridChange?.(true);
            }
        },
        [onOverGridChange, hasFilesTransfer],
    );

    const handleDragLeave = useCallback(
        (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!containerRef.current?.contains(e.relatedTarget)) {
                setDragging(false);
                onOverGridChange?.(false);
            }
        },
        [onOverGridChange],
    );

    const handleDragOver = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        e.dataTransfer.dropEffect = "copy";
    }, []);

    const handleDrop = useCallback(
        (e) => {
            e.preventDefault();
            e.stopPropagation();
            setDragging(false);
            onOverGridChange?.(false);
            onDragEnd?.();

            const data = e.dataTransfer.getData("text/plain");
            if (data?.startsWith("LINQ_CASE_ACTIVITIES:")) return;

            const files = e.dataTransfer.files;
            if (files?.length > 0) onFilesDrop(files);
        },
        [onFilesDrop, onOverGridChange, onDragEnd],
    );

    const showValidOverlay = dragging || (isDraggingFile && isOverGrid);

    return (
        <div
            ref={containerRef}
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
            className={`h-100 ${activityStyles["drop-zone"]}`}>
            {children}
            {showValidOverlay && (
                <div className={activityStyles["drop-overlay"]} aria-hidden>
                    <span className={activityStyles["drop-overlay-title"]}>
                        Drop files here to attach to the case activity
                    </span>
                    <span className={activityStyles["drop-overlay-hint"]}>
                        Release to upload files to the case
                    </span>
                </div>
            )}
        </div>
    );
};
